import angular from 'angular';
import constants from 'app/constants';
import {
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
  oversightDataService,
  oversightSharedModelService,
} from 'app/services';
import {
  actionIcon,
  alerts,
  appReports,
  convertToNumber,
  documentManagement,
  helpTooltip,
} from 'app/components/global';
import editAgendaDialog from './dialog.editAgendaDialog';
import settingsDialog from './dialog.settingsDialog';
import agendas from './agendas';
import controller from './oversight.controller';


export const routeConfig = {
  template: require('./oversight.html'),
  controller: 'OversightController',
  controllerAs: 'oversightVM',
};

export default angular.module('app.components.advisory.oversight', [
  actionIcon,
  alerts,
  appReports,
  agendas,
  constants,
  convertToNumber,
  documentManagement,
  editAgendaDialog,
  helpTooltip,
  loaderService,
  orgDataService,
  settingsDialog,
  ssDialogService,
  userService,
  oversightDataService,
  oversightSharedModelService,
])
  .controller('OversightController', controller)
  .name;

console.log('app.components.advisory.oversight created');
